import { ShieldCheck, Layers, AlertTriangle } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * MDR (Medical Device Regulation) classification badge.
 * - "medical": Software che ricade nel perimetro MDR (es. visualizzatori ECG/Spirometria,
 *   refertazione, algoritmi AI). Tipicamente Classe IIa secondo Regola 11.
 * - "admin": Software gestionale/amministrativo, fuori perimetro MDR.
 * - "mixed": Componenti misti (gateway/trasmissione + visualizzazione).
 */
export const MDRBadge = ({ variant = "admin", size = "sm", className = "" }) => {
  const variants = {
    medical: {
      icon: ShieldCheck,
      label: "Medical Device · MDR Classe IIa",
      classes: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-900"
    },
    admin: {
      icon: Layers,
      label: "Modulo Gestionale · Fuori MDR",
      classes: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900"
    },
    mixed: {
      icon: AlertTriangle,
      label: "Componenti Misti · Gateway",
      classes: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900"
    }
  };

  const v = variants[variant] || variants.admin;
  const Icon = v.icon;
  const sizeCls = size === "lg" ? "text-xs px-3 py-1.5" : "text-[10px] px-2 py-1";
  const iconSize = size === "lg" ? "h-3.5 w-3.5" : "h-3 w-3";

  return (
    <span
      data-testid={`mdr-badge-${variant}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border font-medium tracking-wide uppercase",
        v.classes,
        sizeCls,
        className
      )}
      title={v.label}
    >
      <Icon className={iconSize} />
      {v.label}
    </span>
  );
};

export default MDRBadge;
